import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-plan-cards',
  templateUrl: './plan-cards.component.html',
  styleUrls: ['./plan-cards.component.css']
})
export class PlanCardsComponent implements OnInit {

  @Input() image;
  @Input() title;
  @Input() data;
  @Input() condition;

  constructor() { }

  ngOnInit() {
  }

}
